<template>
    <div class="applyState">
      <van-nav-bar
        title=" 号 牌 领 取"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
      <!-- <van-divider
      :style="{ color: '#1989fa', borderColor: '#1989fa', margin:0,height:'50px'}"
    >
    服 务 站
    </van-divider> -->
    <div class="stationDialog"></div>
    <van-form  style="opacity: .8;">
        <van-cell-group>
          <van-notice-bar style="font-size: 20px;text-align: left;" color="blue" background="#ecf9ff" wrapable >
            请确认 <span style="color: red;font-size: 21px;font-weight: bold;">车牌号码</span> 及 <span style="color: red;font-size: 21px;font-weight: bold;">号牌领取点</span> 
            等信息是否正确，如有填错，将会影响号牌领取！
          </van-notice-bar>

        <van-row >
            <van-cell class="titleStyle"  @click="showPicker = true">号牌领取点：</van-cell>
        </van-row>
        <van-divider style="margin: 0;"/>
        <van-row class="select picker">
        <van-field
          readonly
          clickable
          :value="getPlateValue"
          placeholder="点击选择号牌领取点"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            title="下划查看更多服务站"
            :columns="getPlateOption"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </van-row>
      </van-cell-group>
      <div>
      <div style="margin: 16px;">
        <van-button @click="goNext" round block type="info">提交</van-button>
        <van-button  @click="goHome" round style="width: 98%; margin-top: 2%;margin-left: 0;">返回首页</van-button>
      </div>
    </div>
    </van-form>

    <!-- 消息确认框 -->
  <van-dialog  class="applyDialog" title="确认填写信息" show-cancel-button  v-model = "dialogVisible" ref="certDialog" @confirm="handleDialogConfirm(applyMessage)" @close="closeDialog('applyMessage')">
    <van-notice-bar style="font-size: 20px;text-align: left;" color="blue" background="#ecf9ff" wrapable >
        请确认 <span style="color: red;font-size: 21px;font-weight: bold;">车牌号码</span> 及 <span style="color: red;font-size: 21px;font-weight: bold;">号牌领取点</span> 
        等信息是否正确，如有填错，将会影响号牌领取！
    </van-notice-bar>
    <van-cell title="业务受理点："  style="font-size: 15px;">{{ setPlateValue }}</van-cell>
    <van-cell title="号牌领取点："  style="font-size: 15px;">{{ getPlateValue }}</van-cell>
    <van-cell title="身份证号："  style="font-size: 15px;">{{ applyMessage.idNo }}</van-cell>
    <van-cell title="车牌类型："  style="font-size: 15px;">{{ applyMessage.plateType | formatPlateType }}</van-cell>
    <van-cell title="车牌号码："  style="font-size: 15px;">{{ applyMessage.plateNo }}</van-cell>
    <van-cell title="手机号码："  style="font-size: 15px;">{{ applyMessage.phoneNo }}</van-cell>
  </van-dialog>
  
  </div>
  </template>
  <script>
import { Dialog} from 'vant';
import{QueryStationDic,ApplaySubmit} from '../my_js/HttpRequest'
import store from '@/store/index.js'
  export default{
    created(){
      this.getStationDic()
      console.log(store.state.certMessage);
      this.applyMessage = store.state.certMessage
    },
    filters:{
         // 车牌类型显示转换
        formatPlateType: function (row) {
        if (row == 0) {
            return '蓝牌'
        } else if(row == 1) {
            return '绿牌'
        }else{
          return '未定义车牌类型'
        }
    },
    },
    data(){
      return{
        stationDic:[],//服务站字典信息
        showPicker: false,//选项是否显示
        isDisabled:false,//下拉框禁用
        getPlateOption:[],//下拉框选项
        getPlateValue:'',//号牌领取点
        applyMessage:null,//用户的申请信息
        dialogVisible:false,//显示信息确认对话框
        setPlateValue:null,//业务受理点
        getPlateAddress:null,//号牌领取点信息,存储石家庄车管所一所的信息
      }
    },
    methods:{
      showPickers(){
        if(this.isDisabled){

        }else{
          this.showPicker=true
        }
        
      },
      // 返回
      goHome(){
        console.log('返回首页');
        this.$router.push('/home')
        const carNumber= ['冀','A']
        store.commit('setPlateNo', carNumber)
        store.commit('setCertMessage',{})
        store.commit('setStation', [])
        this.$router.push('/home')
      },
      // 返回上一页
      goBack(){
        console.log('返回信息填写');
        this.$router.push('/certMessage')
      },
     
      // 下一步
      goNext() {
        // Dialog.alert({
        //     title: '提交成功 !',
        //     // message: '<span style="color:green">提交成功 !\n\n可通过首页的“取牌查询”按钮，查询车牌是否已经制作完成</span>',
        //     message: '<span style="color:green">       可通过首页的“取牌查询”按钮，查询车牌是否已经制作完成，号牌制作完成后。\n\n       凭<span style="color:#1989fa"> 取牌人身份证 </span>及 <span style="color:#1989fa">《机动车领牌凭证》</span>，到取牌自助机进行领取。</span>',
        //     // message: '<span style="color:green">可通过首页的“取牌查询”按钮，查询车牌是否已经制作完成，号牌制作完成后，凭取牌人身份证及 《 机动车领牌凭证 》 ，到取牌自助机进行领取</span>',
        //     confirmButtonColor:'#1989fa',
        //     theme: 'round-button',
        //     width:'300px',
        //     messageAlign:'left'
        //   }).then(() => {
        //     const carNumber= ['冀','A']
        //     store.commit('setPlateNo', carNumber)
        //     this.$router.push('/home')
        //   });
        //   return
        if(this.getPlateValue == '' || this.getPlateValue == null){
          Dialog.alert({
              title: '提 示',
              message: '<span style="color:#ff9933">请选择号牌领取点</span>',
              confirmButtonColor:'#1989fa',
              theme: 'round-button',
              width:'300px',
            }).then(() => {
              return
            });
        }else{
          this.applyMessage = store.state.certMessage
          console.log('this.applyMessage',this.applyMessage);
          this.dialogVisible = true
        }
      },
   // 获取服务站信息
      getStationDic(){
        QueryStationDic().then(res => {
          console.log(res);
          this.stationsDicInfo = res.data
          console.log('stationsDicInfo',this.stationsDicInfo);

          this.getPlateAddress = this.stationsDicInfo.filter(item => item.code == '130100001001')
          console.log('石家庄车管所一分所',this.getPlateAddress);
          this.getPlateOption.push({text:this.getPlateAddress[0].name,value:this.getPlateAddress[0].code,getStation:this.getPlateAddress[0].getStation})
          console.log(store.state.stationInfo);
          const data = store.state.stationInfo
          if(data.getStation.length > 13){
            this.getPlateOption.push(data)
          }
          this.setPlateValue = data.text
        })
        console.log('getPlateOption:',this.getPlateOption);
        },
       // 选项发生变化
      selectChange(val){
        // debugger
        console.log('val:',val);
        console.log(this.getPlateAddress);
        console.log(store.state.stationInfo);
        console.log(store.state.stationInfo.code);

        if(val == this.getPlateAddress[0].code){
          this.selectStation = this.getPlateAddress
        }else if (val == store.state.stationInfo.code){
          this.selectStation = store.state.stationInfo
        }
        console.log('selectStation',this.selectStation);
          
      },
      // 服务站选项发生变化
      onConfirm(val) {
        console.log('用户选择的号牌领取点',val);
        this.getPlateValue = val.text;
        this.showPicker = false;
        this.applyMessage.getStationCode = val.value
        store.commit('setGetStationCode',this.getPlateValue)
      },
      // 消息确认框点击确定
      handleDialogConfirm(){
        console.log('点击了确定');
        this.dialogVisible = false
          // 提交申请
        console.log('applyMessage',this.applyMessage);
        ApplaySubmit(this.applyMessage).then(res=>{
            console.log('提交数据成功',res);
            Dialog.alert({
            title: '提交成功 !',
            // message: '<span style="color:green">       可通过首页的 “<span style="color:#1989fa"> 取牌查询 </span>” 按钮，查询车牌是否已经制作完成，号牌制作完成后。\n\n       凭<span style="color:#1989fa"> 取牌人身份证 </span>及 <span style="color:#1989fa">《机动车领牌凭证》</span>，到取牌自助机进行领取。</span>',
            message: '<span style="color:green">       可通过首页的 “<span style="color:#1989fa"> 取牌查询 </span>” 按钮，查询车牌是否已经制作完成，号牌制作完成后。\n\n       凭<span style="color:#1989fa"> 取牌人身份证 </span>  到取牌自助机进行领取。</span>',
            confirmButtonColor:'#1989fa',
            theme: 'round-button',
            width:'300px',
            messageAlign:'left'
          }).then(() => {
            const carNumber= ['冀','A']
            store.commit('setPlateNo', carNumber)
            store.commit('setCertMessage',{})
            store.commit('setStation', [])
            this.$router.push('/home')
          });
        })
      },
      // 关闭 dialog
      closeDialog () {
          this.dialogVisible = false
      },
    }
  }
  </script>
  <style lang="scss">
  .applyState{
    width: 100%;
    height: 100%;
    overflow-y: auto; /* 尝试使用 auto */
    background-color: #F7F8FA;
    .van-number-keyboard{
      background-color: #F2F3F5;
      padding: 0;
    }
    .van-key{
      width: 100%;
    }
    .van-cell__value{
      text-align: left;
    }

    .van-button--small{
      padding: 0 10px;
    }
    .van-nav-bar__left{
    left: 0;
    }
    .van-nav-bar .van-icon{
      color: #0283ef;
    }
    .van-nav-bar__text{
      color: #0283ef;
    }

    .stationDialog{
      .van-dialog__confirm{
        background-color: #1989fa;
        color: #fff;
      }
      .van-dialog__cancel{
        background-color: #f6f7f8;
        color: #000;
        border: #e6e8ec 1px solid;
        margin-right: 3px;
      }
      .van-dialog__footer{
        padding: 5px 5px;
      }
      .van-dialog__header{
        color: #000;
      }
      .van-dialog__message--has-title{
        color: #ff9900;
        text-align: left;
      }
      // .van-notice-bar__content {
      //   font-size: 20px;
      // }
      
    }
    .titleStyle{
      .van-cell__value--alone{
        color: #1989fa;
        font-weight: bold;
      }
    }
    .stationPicker{
      // .van-popup--bottom.van-popup--round{
      //   height: 65%;
      // }
      .van-picker__title{
      color: #fa8f04;
      font-weight: bold;
    }
    }
    .select{
      // border: red 1px solid;
      .van-dropdown-menu{
        margin: 2% ;
        border: gainsboro 1px solid;
      }
    }
   
  }
  </style>